module.exports = __webpack_public_path__ + "img/download.77ce065c.png";